import { useMemo, useRef } from "react";

/** Окно свежести пуша MatchLiveData: Tauri шлёт данные игры примерно раз в секунду. */
export const LIVE_PUSH_FRESH_MS = 15_000;

/**
 * Страховочный опрос, который молчит, пока пуш свежий (KAN-983).
 *
 * Доска живой игры и модалка статистики опрашивали данные матча каждые 5 секунд
 * всегда — и когда пуш MatchLiveData шёл. Опрос дублировал поток, а ответ,
 * пришедший позже пуша, перезаписывал свежие данные более старыми.
 *
 * `mark()` — в обработчике пуша, `isFresh()` — в начале тика опроса: если пуш
 * приходил за последние `windowMs`, тик пропускается. Пуш умолк (обрыв, аноним
 * без доступа к хабу, игра не идёт) — через `windowMs` опрос возвращается сам.
 */
export function useRecentPush(windowMs: number) {
  const lastPushAt = useRef(0);
  return useMemo(
    () => ({
      mark: () => {
        lastPushAt.current = Date.now();
      },
      isFresh: () => Date.now() - lastPushAt.current < windowMs,
    }),
    [windowMs],
  );
}
